import reduce from "lodash/reduce";

export default function findCaseInsensitiveAttributeName(source, name) {
  const attributes = source.attributes;

  return reduce(
    attributes,
    (memo, value) => {
      if (value.name.toLowerCase() === name.toLowerCase()) {
        return value.name;
      }

      return memo;
    },
    name,
  );
}
